import { processExperienceEventSync, queuePassiveExperienceEvent } from '../../services/experienceGamificationService'
import type { ExperienceActionType } from '../../types/experienceEngine'

export type TourTelemetryEvent = 'TOUR_STARTED' | 'TOUR_STEP_COMPLETED' | 'TOUR_SKIPPED' | 'TOUR_COMPLETED' | 'TOUR_ERROR'

export interface TourTelemetryInput {
  event: TourTelemetryEvent
  tourId: string
  workspaceId: string
  actorId: string
  actorName?: string | null
  stepId?: string
  targetSelector?: string
  reason?: string
}

/**
 * Routes tour lifecycle events through processExperienceEvent so they land in
 * `user_activity/{uid}/events/{eventId}` + `ledger/{uid}/entries/{eventId}` —
 * the workspace_activity rule blocks client writes after the experience-engine
 * cutover. The action types are registered in EngineRegistry.json with empty
 * gamification ops, so they audit-only with no XP/track/ticket effects.
 */
export const emitTourTelemetry = (input: TourTelemetryInput): void => {
  const action = input.event as ExperienceActionType
  const payload = {
    workspaceId: input.workspaceId || undefined,
    sourceId: input.stepId ?? input.tourId,
    tourId: input.tourId,
    stepId: input.stepId,
    targetSelector: input.targetSelector,
    reason: input.reason,
    title: input.actorName ?? undefined,
  }
  void queuePassiveExperienceEvent(action, payload)
    .then((queued) => queued ? undefined : processExperienceEventSync(action, payload))
    .catch((error) => console.warn('[TOURGUIDE] Telemetry write failed.', error))
}
